import { IStore } from '../index'
import { IClientCalendarEvent } from '../../interfaces/IClientDetails'

export const getClientAppointmentsValue = (state: IStore) =>
  state.clientAppointmentsReducer as IClientCalendarEvent[]
